import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Row, Button } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import ArticlesInventoryAPI from '../api/ArticlesInventoryAPI';

const ArticlesModal = ({ article, closeModal, opened, inventoryTypes,Callback }) => {

    //Articulos
    const [name, setName] = useState(null);
    const [type, setType] = useState(null);
    const [description, setDescription] = useState(null);
    const [stock, setStock] = useState(null);
    const [cost, setCost] = useState(null);
    const [sellPrice, setSellPrice] = useState(null);

    //Sistema
    const [errors, setErrors] = useState({});
    const [openModal, setOpenModal] = useState(opened);
    const [showAlertModal, setAlerShowModal] = useState(false);
    const [messagAlerteModal, setAlertMessageModal] = useState(null);
    const [colorAlertModal, setAlertColorModal] = useState("success");

    useEffect(() => {
        if(article != null && article != undefined)
        {
            loadData();
        }
    }, []);

    const loadData = () => {
        setName(article.articulo);
        setType(article.tipo);
        setDescription(article.descripcion);
        setStock(article.stock);
        setCost(article.costo);
        setSellPrice(article.valor_venta);
    }

    const handleChangeName = (value) => {
        setName(value);
    }

    const handleType = (value) => {
        setType(value);
    }

    const handleStock = (value) => {
        setStock(value);
    }

    const handleDescription = (value) => {
        setDescription(value);
    }

    const handleCost = (value) => {
        setCost(value);
    }

    const handleSellPrice = (value) => {
        setSellPrice(value);
    }

    const handleCloseModal = () => {
        cleanData();
        closeModal();
        Callback();
    }

    const addArticle = async () => {
        let params = {
            articulo:name,
            tipo:type,
            stock:stock,
            costo:cost,
            descripcion:description,
            valor_venta: sellPrice,
        }
        
        await ArticlesInventoryAPI.crearArticuloInventario(params).then((res) => {
            setAlerShowModal(true);
            setAlertColorModal("success");
            setAlertMessageModal("Articulo agregado al Inventario");
        });
    }

    const updateArticle = async () => {
        let params = {
            id_inventario:article.id_inventario,
            articulo:name,
            tipo:type,
            stock:stock,
            costo:cost,
            descripcion:description,
            valor_venta: sellPrice
        }
        
        await ArticlesInventoryAPI.actualizarArticulosInventario(params).then((res) => {
            setAlerShowModal(true);
            setAlertColorModal("success");
            setAlertMessageModal("Articulo actualizado en el Inventario");
        });
    }

    const onOkModal = () => {
        setAlerShowModal(false);
        if(colorAlertModal == "success")
        {
            handleCloseModal();
        }
    }

    const cleanData = () => {
        setName(null);
        setType(null);
        setDescription(null);
        setStock(null);
        setCost(null);
        setSellPrice(null);
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            {article == null ? <h5 className="bold-text">Agregar Articulo</h5>
                                : <h5 className="bold-text">Actualizar Articulo</h5>
                            }
                        </div>
                        <Row>
                            <Col md={6}>
                                <TextField
                                    label="Nombre"
                                    value={name}
                                    onChange={(event) => {
                                        handleChangeName(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                    helperText={errors.hasOwnProperty("name") && name == null ? errors.name : ""}
                                    error={errors.hasOwnProperty("name") && name == null ? true : false}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    className="medical-material-form__field"
                                    select
                                    name="tipo"
                                    id="tipo"
                                    label="Tipo"
                                    value={type}
                                    onChange={(event) => {
                                        handleType(event.target.value);
                                    }}
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    {
                                        inventoryTypes.map((inventoryType) => {
                                            return (<MenuItem value={inventoryType.id_inventario_tipos} >{inventoryType.tipo}</MenuItem>);
                                        })
                                    }
                                </TextField>
                            </Col>
                            <Col md={6}>
                                <TextField
                                    label="Stock Disponible"
                                    value={stock}
                                    onChange={(event) => {
                                        handleStock(event.target.value);
                                    }}
                                    type="number"
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                    helperText={errors.hasOwnProperty("stock") && stock == null ? errors.stock : ""}
                                    error={errors.hasOwnProperty("stock") && stock == null ? true : false}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    label="Costo"
                                    value={cost}
                                    onChange={(event) => {
                                        handleCost(event.target.value);
                                    }}
                                    type="number"
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                    helperText={errors.hasOwnProperty("cost") && cost == null ? errors.cost : ""}
                                    error={errors.hasOwnProperty("cost") && cost == null ? true : false}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    label="Descripcion"
                                    value={description}
                                    onChange={(event) => {
                                        handleDescription(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                    helperText={errors.hasOwnProperty("description") && description == null ? errors.description : ""}
                                    error={errors.hasOwnProperty("description") && description == null ? true : false}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    label="Valor de Venta"
                                    value={sellPrice}
                                    onChange={(event) => {
                                        handleSellPrice(event.target.value);
                                    }}
                                    type="number"
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                    helperText={errors.hasOwnProperty("sellPrice") && sellPrice == null ? errors.sellPrice : ""}
                                    error={errors.hasOwnProperty("sellPrice") && sellPrice == null ? true : false}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {article == null ? <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                addArticle();
                            }}
                        >
                            Crear
                        </Button> : <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                updateArticle();
                            }}
                        >
                            Actualizar
                        </Button>}
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                handleCloseModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => onOkModal()}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ArticlesModal;
